import { View } from 'react-native';
import { DriverLimitsSummary } from './DriverLimitsCard';
import { WorkStateHeader } from './WorkStateHeader';
import type { DriverLimits, DriverWorkStateSnapshot } from './types';

/**
 * Content of the status card at the top of the driver home. It replaces the
 * state title, the «Condução hoje» line and <DrivingLimitNotice /> in
 * DashboardContent; <WorkContextCard /> stays below it unchanged.
 */
export const WorkTimeStatusPanel = ({
  snapshot,
  limits,
  onOpenLimits,
  large,
  nowMs,
}: {
  snapshot: DriverWorkStateSnapshot;
  limits: DriverLimits;
  onOpenLimits?: () => void;
  large?: boolean;
  nowMs?: number;
}) => (
  <View testID="work-time-status-panel" style={{ gap: 12 }}>
    <WorkStateHeader snapshot={snapshot} large={large} />
    <DriverLimitsSummary limits={limits} onOpen={onOpenLimits} nowMs={nowMs} />
  </View>
);
